<ul class="list-unstyled disclaimer">
  <li><a (click)="openAboutUs()">About Us</a></li>
  <li><a (click)="disclaimer()">Disclaimer</a></li>
  <li><a (click)="openTermsOfUse()">Terms of Use</a></li>
  <li><a (click)="openContactUs()">Contact Us</a></li>
</ul>
